import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Modal from '../../assets/styles/Modal';
import Text from '../../assets/styles/Text';
import ReactPortal from '../ReactPortal';
import * as styles from './styles';

export default function PopUpEntering() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const hasEntered = localStorage.getItem(
      process.env.REACT_APP_LOCAL_STORAGE_ENTERING_KEY
    );

    if (!hasEntered) {
      setShow(true);
    }
  }, []);

  function handleShow() {
    localStorage.setItem(
      process.env.REACT_APP_LOCAL_STORAGE_ENTERING_KEY,
      'true'
    );

    setShow(false);
  }

  if (!show) return null;

  return (
    <ReactPortal containerId="PopUpEntering">
      <Modal onClick={handleShow}>
        <styles.Container>
          <styles.Title>
            <Text.H1>18+</Text.H1>
            <div>
              <Text.H3>Conteúdo</Text.H3>
              <Text.H2>Adulto</Text.H2>
            </div>
          </styles.Title>

          <styles.Description>
            <Text.P>
              <b>AVISO</b>: Este site contém <b>conteúdo explícito</b> destinado
              exclusivamente a adultos. Ao continuar, você confirma que tem{' '}
              <b>18 anos ou mais</b> e concorda com nossos termos de uso. Se
              você não atender a esses requisitos, por favor saia agora.
            </Text.P>

            <Link to="/home">Termo de serviço</Link>
            <Link to="/home">Politicas de privacidade</Link>
          </styles.Description>

          <styles.GroupButton>
            <button type="button" onClick={handleShow}>
              Continuar
            </button>
          </styles.GroupButton>
        </styles.Container>
      </Modal>
    </ReactPortal>
  );
}
